import { createContext, useContext } from 'react';

// Supporting Tools and Supporting Tools Live are the same screens mounted twice,
// so every page asks this context where it is mounted instead of hard-coding
// '/dashboard/supporting-tools'. `variant` also decides which screens are shown
// (those still in Supporting Tools, or those moved to Live) and which module's
// per-screen rights apply.
export const STANDARD = {
  variant: 'standard',
  basePath: '/dashboard/supporting-tools',
  title: 'Supporting Tools',
  subtitle: 'Connect clients and run operational tools',
};

export const LIVE = {
  variant: 'live',
  basePath: '/dashboard/supporting-tools-live',
  title: 'Supporting Tools Live',
  subtitle: 'Connect clients and run the screens moved to live',
};

const SupportingToolsContext = createContext(STANDARD);

export const SupportingToolsProvider = SupportingToolsContext.Provider;

export const useSupportingTools = () => useContext(SupportingToolsContext);
